import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import {
  StyledSubnav,
  StyledGroup,
  StyledGroupTitle,
  StyledItem,
  StyledItemDesc,
  StyledTitle
} from './TopbarTalentSubnav.styled';

const TopbarFreelanceSubnav: React.FC = () => {
  const { t } = useI18n('topbar');
  const { locale } = useRouter();

  return (
    <StyledSubnav>
      <StyledGroup>
        <StyledTitle>{t('freelance_subnav.title')}</StyledTitle>
        <p>{t('freelance_subnav.desc')}</p>
      </StyledGroup>
      <StyledGroup>
        <StyledGroupTitle>{t('freelance_subnav.offer.title')}</StyledGroupTitle>
        <Link href={getAppUrl(APP_URLS.freelanceCompanies, locale)} passHref>
          <StyledItem>
            <div>
              <span>{t('freelance_subnav.companies.title')}</span>
              <StyledItemDesc>
                {t('freelance_subnav.companies.desc')}
              </StyledItemDesc>
            </div>
          </StyledItem>
        </Link>
        <Link href={getAppUrl(APP_URLS.freelanceTalent, locale)} passHref>
          <StyledItem>
            <div>
              <span>{t('freelance_subnav.talent.title')}</span>
              <StyledItemDesc>
                {t('freelance_subnav.talent.desc')}
              </StyledItemDesc>
            </div>
          </StyledItem>
        </Link>
      </StyledGroup>
      <StyledGroup>
        <StyledGroupTitle>
          {t('freelance_subnav.guides.title')}
        </StyledGroupTitle>
        <Link
          href={`${getAppUrl(APP_URLS.blog, locale)}${
            locale === 'en'
              ? '/guide-how-to-work-with-freelance-in-tech'
              : '/guia-como-trabajar-con-freelance-en-tech-manfred'
          }`}
          passHref
        >
          <StyledItem>
            <div>
              <span>{t('freelance_subnav.guides.companies_guide')}</span>
            </div>
          </StyledItem>
        </Link>
        <Link
          href={`${getAppUrl(APP_URLS.blog, locale)}${
            locale === 'en'
              ? '/guide-for-freelance-newbies-in-tech'
              : '/guia-para-freelance-novatos-en-tech-manfred'
          }`}
          passHref
        >
          <StyledItem>
            <div>
              <span>{t('freelance_subnav.guides.talent_guide')}</span>
            </div>
          </StyledItem>
        </Link>
      </StyledGroup>
    </StyledSubnav>
  );
};

export default TopbarFreelanceSubnav;
